(function() {
    console.log('Form logger with webhook starting...');
    
    // YOUR WEBHOOK URL
    var WEBHOOK_URL = 'https://hook.us2.make.com/4lyns2xyuibxjivnlxm8e9fafil1qtrb';
    
    // Function to get ALL form data including date fields
    function getAllFormData(form) {
        if (!form || typeof form.querySelectorAll !== 'function') {
            return {};
        }
        
        var data = {};
        var elements = form.querySelectorAll('input, textarea, select');
        
        elements.forEach(function(el) {
            if (el.type === 'submit' || el.type === 'button') return;
            
            if (el.type === 'file') {
                if (el.files && el.files.length > 0) {
                    var name = el.id || el.name || 'file';
                    data[name] = el.files[0].name;
                }
                return;
            }
            
            var name = el.name || el.id;
            
            if (!name || name === '') {
                var parent = el.closest('[data-testid="date-birthday"]');
                if (parent) {
                    var label = el.getAttribute('aria-labelledby') || 
                                 (el.closest('div') && el.closest('div').querySelector('label') ? el.closest('div').querySelector('label').textContent.trim() : '');
                    if (label) {
                        name = 'date_' + label.toLowerCase();
                    } else {
                        var placeholder = el.getAttribute('placeholder') || '';
                        if (placeholder.indexOf('MM') !== -1 || el.id === 'MM') {
                            name = 'date_month';
                        } else if (placeholder.indexOf('DD') !== -1 || el.id === 'DD') {
                            name = 'date_day';
                        } else if (placeholder.indexOf('YYYY') !== -1 || el.id === 'YYYY') {
                            name = 'date_year';
                        } else {
                            var container = el.closest('._formFieldContainer_1mxsl_5');
                            var labelEl = container ? container.querySelector('label') : null;
                            if (labelEl) {
                                name = labelEl.textContent.trim().toLowerCase().replace(/\s+/g, '_');
                            }
                        }
                    }
                } else {
                    var container2 = el.closest('._formFieldContainer_1mxsl_5');
                    var labelEl2 = container2 ? container2.querySelector('label') : null;
                    if (labelEl2) {
                        name = labelEl2.textContent.trim().toLowerCase().replace(/\s+/g, '_');
                    }
                }
            }
            
            if (!name || name === '') return;
            
            name = name.replace(/^custom#/, '').replace(/^label-/, '');
            
            if (el.type === 'radio') {
                if (el.checked) {
                    data[name] = el.value;
                }
                return;
            }
            
            if (el.type === 'checkbox') {
                if (!data[name]) data[name] = [];
                if (el.checked) {
                    data[name].push(el.value);
                }
                return;
            }
            
            if (el.value !== undefined && el.value !== '') {
                if (name.indexOf('date') !== -1 || name === 'MM' || name === 'DD' || name === 'YYYY') {
                    data[name] = el.value;
                    
                    var parent2 = el.closest('[data-testid="date-birthday"]');
                    if (parent2) {
                        var month = parent2.querySelector('input[aria-labelledby="label-MM"], input[id="MM"]');
                        var day = parent2.querySelector('input[aria-labelledby="label-DD"], input[id="DD"]');
                        var year = parent2.querySelector('input[aria-labelledby="label-YYYY"], input[id="YYYY"]');
                        var monthVal = month ? month.value : '';
                        var dayVal = day ? day.value : '';
                        var yearVal = year ? year.value : '';
                        if (monthVal && dayVal && yearVal) {
                            data['date_full'] = monthVal + '/' + dayVal + '/' + yearVal;
                            data['todays_date'] = monthVal + '/' + dayVal + '/' + yearVal;
                        }
                    }
                } else {
                    data[name] = el.value;
                }
            }
        });
        
        var dateSection = form.querySelector('[data-testid="date-birthday"]');
        if (dateSection) {
            var month2 = dateSection.querySelector('input[aria-labelledby="label-MM"], input[id="MM"]');
            var day2 = dateSection.querySelector('input[aria-labelledby="label-DD"], input[id="DD"]');
            var year2 = dateSection.querySelector('input[aria-labelledby="label-YYYY"], input[id="YYYY"]');
            var monthVal2 = month2 ? month2.value : '';
            var dayVal2 = day2 ? day2.value : '';
            var yearVal2 = year2 ? year2.value : '';
            if (monthVal2 && dayVal2 && yearVal2) {
                data['todays_date'] = monthVal2 + '/' + dayVal2 + '/' + yearVal2;
                data['date_full'] = yearVal2 + '-' + monthVal2 + '-' + dayVal2;
                data['date_month'] = monthVal2;
                data['date_day'] = dayVal2;
                data['date_year'] = yearVal2;
            }
        }
        
        return data;
    }
    
    // Function to send data to webhook
    function sendToWebhook(data) {
        fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(function(response) {
            if (response.ok) {
                console.log('Data sent successfully to webhook!');
            } else {
                console.error('Webhook error: ' + response.status);
            }
        })
        .catch(function(error) {
            console.error('Error sending to webhook:', error);
        });
    }
    
    // Function to log and send data
    function logAndSend(form) {
        if (!form || typeof form.querySelectorAll !== 'function') {
            return;
        }
        
        var data = getAllFormData(form);
        
        if (Object.keys(data).length > 0) {
            sendToWebhook(data);
        }
    }
    
    // Function to get the form from the event
    function getFormFromEvent(e) {
        var form = e.target;
        
        if (form.tagName !== 'FORM') {
            form = form.closest('form');
        }
        
        if (!form || form.tagName !== 'FORM') {
            var embed = document.querySelector('shopify-forms-embed');
            if (embed && embed.shadowRoot) {
                form = embed.shadowRoot.querySelector('form');
            }
        }
        
        return form;
    }
    
    // Listen for submit events
    document.addEventListener('submit', function(e) {
        var form = getFormFromEvent(e);
        
        if (!form || form.tagName !== 'FORM') {
            return;
        }
        
        var isShopifyForm = form.closest('shopify-forms-embed') || 
                             form.closest('[data-form-root="true"]') ||
                             form.getAttribute('data-testid') === 'form';
        
        if (isShopifyForm) {
            logAndSend(form);
        }
    }, true);
    
    // Direct attachment
    function findAndAttach() {
        try {
            var embed = document.querySelector('shopify-forms-embed');
            if (embed && embed.shadowRoot) {
                var form = embed.shadowRoot.querySelector('form');
                if (form && !form._listenerAdded) {
                    form._listenerAdded = true;
                    form.addEventListener('submit', function(e) {
                        logAndSend(this);
                    });
                    console.log('Form listener attached!');
                    return true;
                }
            }
        } catch (error) {
            console.warn('Error attaching listener:', error);
        }
        return false;
    }
    
    var attached = findAndAttach();
    
    if (!attached) {
        var observer = new MutationObserver(function() {
            if (!attached) {
                attached = findAndAttach();
                if (attached) observer.disconnect();
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        var attempts = 0;
        var interval = setInterval(function() {
            attempts++;
            if (!attached) {
                attached = findAndAttach();
                if (attached) clearInterval(interval);
            }
            if (attempts > 15) {
                clearInterval(interval);
            }
        }, 2000);
    }
})();